import store from '../state/store'
import axios from 'axios'

store.on('pricing_calculator:initialize', function(lesson_order) {
  store.get().set({pricing_calculator: null})

  axios.post(`/api/sales/lesson_orders/${lesson_order.id}/pricing_calculators`)
  .then(function(response) {
    store.get().set({pricing_calculator: response.data.pricing_calculator})
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('pricing_calculator:fetch', function(lesson_order) {
  axios.post(`/api/sales/lesson_orders/${lesson_order.id}/pricing_calculators`)
  .then(function(response) {
    store.get().set({pricing_calculator: response.data.pricing_calculator})
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('pricing_calculator:inputs:update', function(params) {
  const state = store.get()
  state.set({change_applied: true})

  store.get().pricing_calculator.inputs.set(params)
  store.emit('pricing_calculator:retrieve')
})

store.on('pricing_calculator:retrieve', function() {
  const pricing_calculator = store.get().pricing_calculator
  
  const post_params = {
    inputs: pricing_calculator.inputs
  }

  axios.post("/api/sales/pricing_calculators", post_params)
  .then(function(response) {
    store.get().set({pricing_calculator: response.data.pricing_calculator})
  })
  .catch(function(error) {
    handleError(error)
  })
})